import type { ErrorMap } from '@/app/error-registry';

export const ORGANIZATION_UNITS_ERROR_MAP: ErrorMap = {
  POST: {
    'Area.CannotAssignClient': 'organization-units:apiErrors.cannotAssignClient',
    'Area.InvalidParent': 'organization-units:apiErrors.invalidParent',
    'Area.CircularReference': 'organization-units:apiErrors.circularReference',
    'AreaName.Empty': 'organization-units:apiErrors.nameEmpty',
    'AreaName.TooShort': 'organization-units:apiErrors.nameTooShort',
    'AreaName.TooLong': 'organization-units:apiErrors.nameTooLong',
    'AreaName.InvalidFormat': 'organization-units:apiErrors.nameInvalidFormat',
    'AreaColor.Empty': 'organization-units:apiErrors.colorEmpty',
    'AreaColor.InvalidFormat': 'organization-units:apiErrors.colorInvalidFormat',
    default: 'organization-units:apiErrors.createDefault',
  },
  PUT: {
    'Area.NotFound': 'organization-units:apiErrors.notFound',
    'Area.CannotAssignClient': 'organization-units:apiErrors.cannotAssignClient',
    'Area.InvalidParent': 'organization-units:apiErrors.invalidParent',
    'Area.CircularReference': 'organization-units:apiErrors.circularReference',
    'AreaName.Empty': 'organization-units:apiErrors.nameEmpty',
    'AreaName.TooShort': 'organization-units:apiErrors.nameTooShort',
    'AreaName.TooLong': 'organization-units:apiErrors.nameTooLong',
    'AreaName.InvalidFormat': 'organization-units:apiErrors.nameInvalidFormat',
    'AreaColor.Empty': 'organization-units:apiErrors.colorEmpty',
    'AreaColor.InvalidFormat': 'organization-units:apiErrors.colorInvalidFormat',
    default: 'organization-units:apiErrors.updateDefault',
  },
  DELETE: {
    'Area.NotFound': 'organization-units:apiErrors.notFound',
    'Area.HasChildren': 'organization-units:apiErrors.hasChildren',
    'Area.HasMembers': 'organization-units:apiErrors.hasMembers',
    default: 'organization-units:apiErrors.deleteDefault',
  },
};
